(()=>{
'use strict';
function init(){
  let config={};
  const data=document.getElementById('pantry-tour-data');
  if(data){try{config=JSON.parse(data.textContent);}catch{config={};}}
  const screens=config.screens||{};
  const tabs=[...document.querySelectorAll('[data-screen]')];
  const panel=document.getElementById('tour-panel');
  const tourImage=document.getElementById('tour-screen');
  function selectScreen(key,focus=false){
    const state=screens[key];
    if(!state||!panel||!tourImage)return;
    for(const tab of tabs){const active=tab.dataset.screen===key;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;if(active&&focus)tab.focus();}
    panel.setAttribute('aria-labelledby',`tab-${key}`);
    tourImage.src=state.image;
    tourImage.srcset=[330,660,990].map(width=>state.image.replace(/([?&])width=\d+/,'$1width='+width)+' '+width+'w').join(', ');
    tourImage.alt=state.alt;
    for(const [id,prop] of [['tour-title','title'],['tour-description','description'],['tour-detail','detail'],['tour-badge','badge'],['tour-caption','caption']]){const element=document.getElementById(id);if(element)element.textContent=state[prop];}
  }
  for(const tab of tabs){
    if(tab.dataset.bound)continue;tab.dataset.bound='true';
    tab.addEventListener('click',()=>selectScreen(tab.dataset.screen));
    tab.addEventListener('keydown',event=>{
      const index=tabs.indexOf(tab);let next;
      if(['ArrowRight','ArrowDown'].includes(event.key))next=(index+1)%tabs.length;
      else if(['ArrowLeft','ArrowUp'].includes(event.key))next=(index+tabs.length-1)%tabs.length;
      else if(event.key==='Home')next=0;
      else if(event.key==='End')next=tabs.length-1;
      else return;
      event.preventDefault();selectScreen(tabs[next].dataset.screen,true);
    });
  }
  if(panel&&tourImage&&tabs.length&&tabs.every(tab=>screens[tab.dataset.screen])){
    panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby','tab-list');
    document.querySelector('.tour-tabs').dataset.enhanced='true';
    const fallback=document.querySelector('.tour-fallback');if(fallback)fallback.hidden=true;
  }
  for(const button of document.querySelectorAll('[data-colour]')){
    if(button.dataset.bound)continue;button.dataset.bound='true';
    button.addEventListener('click',()=>{
      const colour=config.colours?.[button.dataset.colour];
      const image=document.getElementById('selected-icon');
      const caption=document.getElementById('icon-caption');
      if(!colour||!image||!caption)return;
      for(const other of document.querySelectorAll('[data-colour]'))other.setAttribute('aria-pressed',String(other===button));
      image.src=colour.image;image.alt=colour.alt;caption.textContent=colour.name;
    });
  }
  const colours=document.querySelector('.colour-options');
  if(colours&&config.colours&&[...colours.querySelectorAll('[data-colour]')].every(button=>config.colours[button.dataset.colour]))colours.dataset.enhanced='true';
  const feedback=document.querySelector('[data-pantry-form-feedback]');
  if(feedback&&!feedback.dataset.focused){feedback.dataset.focused='true';feedback.focus();}
  const menuButton=document.querySelector('.menu-toggle');
  const nav=document.getElementById('primary-nav');
  if(!menuButton||!nav)return;
  let current=document.querySelector('[data-pantry-template]')?.dataset.pantryTemplate;
  if(current==='pantry-tag-example')current='pantry-tags';
  for(const link of nav.querySelectorAll('[data-pantry-page]')){if(current==='pantry-'+link.dataset.pantryPage)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');}
  if(menuButton.dataset.bound)return;menuButton.dataset.bound='true';
  function setMenu(open){menuButton.setAttribute('aria-expanded',String(open));nav.dataset.open=String(open);}
  menuButton.addEventListener('click',()=>setMenu(menuButton.getAttribute('aria-expanded')!=='true'));
  for(const link of nav.querySelectorAll('a'))link.addEventListener('click',()=>setMenu(false));
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&menuButton.getAttribute('aria-expanded')==='true'){setMenu(false);menuButton.focus();}});
  document.addEventListener('click',event=>{if(menuButton.getAttribute('aria-expanded')==='true'&&!event.target.closest('.header-inner'))setMenu(false);});
  window.matchMedia('(min-width:641px)').addEventListener('change',event=>{if(event.matches)setMenu(false);});
  nav.dataset.enhanced='true';menuButton.dataset.enhanced='true';
}
init();document.addEventListener('shopify:section:load',init);
})();

